import { round } from "./round";

export const formatPercentage = (percentage: number | null | undefined) => {
  if (!percentage) {
    return "0%";
  }

  return `${round(percentage, 2)}%`;
};
